"use client";

import { cn } from "../../cn";

export function WhatsaAppIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 150 151"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M128.144 21.9023C114.045 7.78542 95.2942 0.00716229 75.315 0C34.1462 0 0.641025 33.5017 0.6267 74.6812C0.619538 87.8454 4.06102 100.695 10.5966 112.018L0 150.723L39.5932 140.338C50.5012 146.29 62.7846 149.423 75.2829 149.427H75.315C116.477 149.427 149.986 115.922 150 74.7421C150.007 54.7846 142.247 36.0228 128.144 21.9059V21.9023ZM75.315 136.814H75.29C64.1525 136.811 53.2267 133.817 43.6937 128.162L41.4267 126.816L17.9308 132.979L24.2014 110.07L22.726 107.721C16.5127 97.8371 13.2287 86.4129 13.2359 74.685C13.2502 40.4598 41.0972 12.6128 75.3404 12.6128C91.9208 12.62 107.506 19.084 119.227 30.8194C130.948 42.5512 137.398 58.1508 137.391 74.735C137.376 108.964 109.53 136.811 75.315 136.811V136.814ZM109.365 90.3237C107.499 89.3892 98.3242 84.8767 96.6121 84.2537C94.9004 83.6304 93.6579 83.3192 92.415 85.1883C91.1725 87.0579 87.595 91.2621 86.5063 92.5046C85.4175 93.7508 84.3287 93.905 82.4629 92.97C80.5975 92.0354 74.5846 90.0658 67.4546 83.7092C61.9075 78.76 58.1613 72.6508 57.0729 70.7812C55.9842 68.9121 56.9583 67.9021 57.8892 66.9746C58.7271 66.1367 59.755 64.7937 60.6896 63.705C61.6246 62.6162 61.9325 61.8358 62.5554 60.5929C63.1787 59.3467 62.8671 58.2583 62.4017 57.3233C61.9358 56.3888 58.2046 47.2029 56.6467 43.4679C55.1317 39.8295 53.5921 40.3237 52.4496 40.2629C51.3608 40.2091 50.1183 40.1984 48.8721 40.1984C47.6258 40.1984 45.6058 40.664 43.8942 42.5333C42.1825 44.4025 37.3621 48.9183 37.3621 58.1004C37.3621 67.2825 44.0483 76.1604 44.9829 77.4067C45.9175 78.6529 58.1433 97.5004 76.8621 105.587C81.3137 107.51 84.7908 108.659 87.5017 109.519C91.9712 110.94 96.0392 110.74 99.255 110.26C102.84 109.723 110.296 105.744 111.85 101.386C113.404 97.0275 113.404 93.2887 112.939 92.5117C112.473 91.7346 111.227 91.2654 109.361 90.3308L109.365 90.3237Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FeedIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M34.8 29.7V11c0-2.9-2.3-5.2-5.2-5.2H11c-2.9 0-5.2 2.3-5.2 5.2v18.7c0 2.9 2.3 5.2 5.2 5.2h18.7c2.8-.1 5.1-2.4 5.1-5.2zM39.2 15v16.1c0 4.5-3.7 8.2-8.2 8.2H14.9c-.6 0-.9.7-.5 1.1 1 1.1 2.4 1.8 4.1 1.8h13.4c5.7 0 10.3-4.6 10.3-10.3V18.5c0-1.6-.7-3.1-1.8-4.1-.5-.4-1.2 0-1.2.6z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function ReelIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="m12.823 1 2.974 5.002h-5.58l-2.65-4.971c.206-.013.419-.022.642-.027L8.55 1Zm2.327 0h.298c3.06 0 4.468.754 5.64 1.887a6.007 6.007 0 0 1 1.596 2.82l.07.295h-4.629L15.15 1Zm-9.667.377L7.95 6.002H1.244a6.01 6.01 0 0 1 3.942-4.53Zm9.735 12.834-4.545-2.624a.909.909 0 0 0-1.356.668l-.008.12v5.248a.91.91 0 0 0 1.255.84l.109-.053 4.545-2.624a.909.909 0 0 0 .1-1.507l-.1-.068-4.545-2.624Zm-14.2-6.209h21.964l.015.36.003.189v6.899c0 3.061-.755 4.469-1.888 5.64-1.151 1.114-2.5 1.856-5.33 1.909l-.334.003H8.551c-3.06 0-4.467-.755-5.64-1.889-1.114-1.15-1.854-2.498-1.908-5.33L1 15.45V8.551l.003-.189Z"
        fillRule="evenodd"
        fill="currentColor"
      ></path>
    </svg>
  );
}

/** Glifo oficial do YouTube Shorts. */
export function ShortsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="m18.931 9.99-1.441-.601 1.717-.913a4.48 4.48 0 0 0 1.874-6.078 4.506 4.506 0 0 0-6.09-1.874L4.792 5.929a4.504 4.504 0 0 0-2.402 4.193 4.521 4.521 0 0 0 2.666 3.904c.036.012 1.442.6 1.442.6l-1.706.901a4.51 4.51 0 0 0-2.369 3.967A4.528 4.528 0 0 0 6.93 24c.725 0 1.437-.174 2.08-.508l10.21-5.406a4.494 4.494 0 0 0 2.39-4.192 4.525 4.525 0 0 0-2.678-3.904ZM9.597 15.19V8.824l6.007 3.184z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * Stories não tem glifo de marca publicado — o que a rede usa é o anel
 * segmentado em volta do avatar. É esse anel, desenhado sólido para conviver
 * com os glifos de marca dos outros formatos.
 */
export function StoriesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M13.108 1.458A10.6 10.6 0 0 1 18.671 3.762L17.286 5.472A8.4 8.4 0 0 0 12.878 3.646ZM20.238 5.329A10.6 10.6 0 0 1 22.542 10.892L20.354 11.122A8.4 8.4 0 0 0 18.528 6.714ZM22.542 13.108A10.6 10.6 0 0 1 20.238 18.671L18.528 17.286A8.4 8.4 0 0 0 20.354 12.878ZM18.671 20.238A10.6 10.6 0 0 1 13.108 22.542L12.878 20.354A8.4 8.4 0 0 0 17.286 18.528ZM10.892 22.542A10.6 10.6 0 0 1 5.329 20.238L6.714 18.528A8.4 8.4 0 0 0 11.122 20.354ZM3.762 18.671A10.6 10.6 0 0 1 1.458 13.108L3.646 12.878A8.4 8.4 0 0 0 5.472 17.286ZM1.458 10.892A10.6 10.6 0 0 1 3.762 5.329L5.472 6.714A8.4 8.4 0 0 0 3.646 11.122ZM5.329 3.762A10.6 10.6 0 0 1 10.892 1.458L11.122 3.646A8.4 8.4 0 0 0 6.714 5.472Z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * Live também não tem glifo de marca — as redes usam a palavra "LIVE" ou o
 * ponto de transmissão com as ondas. Aqui é o ponto com as ondas, sólido.
 */
export function LiveIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M15.192 5.996A6.8 6.8 0 0 1 15.192 18.004L14.441 16.591A5.2 5.2 0 0 0 14.441 7.409ZM8.808 18.004A6.8 6.8 0 0 1 8.808 5.996L9.559 7.409A5.2 5.2 0 0 0 9.559 16.591ZM18.403 3.805A10.4 10.4 0 0 1 18.403 20.195L17.418 18.934A8.8 8.8 0 0 0 17.418 5.066ZM5.597 20.195A10.4 10.4 0 0 1 5.597 3.805L6.582 5.066A8.8 8.8 0 0 0 6.582 18.934ZM12 8.9a3.1 3.1 0 1 1 0 6.2 3.1 3.1 0 0 1 0-6.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * Vídeo aparece no TikTok, no YouTube, no Pinterest e em "outra" — não é de
 * uma marca só, então é o play na tela, sólido, na mesma massa dos glifos.
 */
export function VideoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M4.5 3.4h15A2.6 2.6 0 0 1 22.1 6v8.8a2.6 2.6 0 0 1-2.6 2.6h-15A2.6 2.6 0 0 1 1.9 14.8V6a2.6 2.6 0 0 1 2.6-2.6Zm5.1 4.2v5.6l4.9-2.8-4.9-2.8Z"
        fillRule="evenodd"
        fill="currentColor"
      />
      <path
        d="M8.6 19.4h6.8a1.1 1.1 0 0 1 0 2.2H8.6a1.1 1.1 0 0 1 0-2.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * Post é o formato do Threads, do LinkedIn e do Pinterest — texto num cartão.
 * Sem glifo de marca; sólido como os outros.
 */
export function PostIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        d="M4.4 2.6h15.2a2.8 2.8 0 0 1 2.8 2.8v13.2a2.8 2.8 0 0 1-2.8 2.8H4.4a2.8 2.8 0 0 1-2.8-2.8V5.4a2.8 2.8 0 0 1 2.8-2.8Zm2.2 5.1a1 1 0 0 0 0 2h10.8a1 1 0 1 0 0-2H6.6Zm0 3.3a1 1 0 1 0 0 2h10.8a1 1 0 1 0 0-2H6.6Zm0 3.3a1 1 0 1 0 0 2h6.4a1 1 0 1 0 0-2H6.6Z"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
}
